import React from "react"
import {Claims, useIsUnitUser} from "../../services/auth"
import {CheckDeposit} from "../../resources/checkDeposits"
import {Resource} from "../../resources/common"
import {CheckDepositAssignmentDetails} from "./CheckDepositAssignmentDetails"

interface AssignmentCheckDepositProps {
	checkDeposit?: CheckDeposit
	claims?: Claims
	included?: Resource[]
}

export default function AssignmentCheckDepositDetails({checkDeposit, claims, included}: AssignmentCheckDepositProps) {
	const isUnitUser = useIsUnitUser(claims)
	const primaryCustomerId = checkDeposit?.relationships.customer?.data.id
	const jointCustomerIds = checkDeposit?.relationships.customers?.data.map((customer) => customer.id) ?? []
	const namesAtUnitCustomerId = primaryCustomerId ?? jointCustomerIds[0]

	return (
		<div className="assignment-item-details-container assignment-check-deposit-details-container">
			{checkDeposit && (
				<CheckDepositAssignmentDetails
					checkDeposit={checkDeposit}
					orgId={isUnitUser ? checkDeposit.relationships.org?.data.id : undefined}
					include={included}
					withCustomerDetails
					namesAtUnitCustomerId={isUnitUser && namesAtUnitCustomerId ? namesAtUnitCustomerId.toString() : undefined}
				/>
			)}
		</div>
	)
}
